var Form = (function () {

    var handleStart = function () {
        toggleEmailFields()

        jQuery('select#applicant-type').change(function() {
            toggleEmailFields()
        })
    }

    var handleStep1 = function () {
        toggleQuotationNo()

        jQuery('input[name="application_type"]').click(function() {
            toggleQuotationNo()
        })
    }

    var handleStep2 = function () {

    }

    var handleStep4 = function () {
        // fix for custom file input
        var element =  document.querySelector('.custom-file-input')
        if (typeof(element) != 'undefined' && element != null) {
            document.querySelector('.custom-file-input').addEventListener('change', function (e) {
                var fileName = document.getElementById("file-input").files[0].name;
                var nextSibling = e.target.nextElementSibling
                nextSibling.innerText = fileName
            })
        }
    }

    var handleDeleteFile = (function () {
        jQuery('#deleteFileModal').on('show.bs.modal', function (ev) {
            var fileId = ev.relatedTarget.rel
            jQuery('#deleteFileModal input#file-id').val(fileId)
        })

        jQuery('button#deleteFileSubmit').click(function (ev) {
            ev.preventDefault()

            var applicationId = jQuery('#deleteFileModal input#application-id').val()
            var fileId = jQuery('#deleteFileModal input#file-id').val()

            jQuery.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': jQuery('meta[name="csrf-token"]').attr('content')
                }
            })

            jQuery.ajax({
                url: '/form/' + applicationId + '/file/' + fileId,
                method: 'delete',
                type: 'delete',
                data: {
                    '_method': 'delete',
                },
                success: function (result) {
                    if (result === 'ok') {
                        location.reload();
                    } else {
                        jQuery('#deleteFavoriteModal').modal('hide')
                        alert('Oeps... Er ging iets fout.\nProbeer het later opnieuw.')
                    }
                }
            })
        })
    })

    function toggleEmailFields() {
        hideEmailFields();

        var type = jQuery('#applicant-type').val();
        jQuery('.email-' + type).show();
        jQuery('.email-' + type + ' input').attr('required', true);
    }

    function hideEmailFields() {
        jQuery('.email-architect').hide();
        jQuery('.email-architect input').attr('required', false);

        jQuery('.email-installer').hide();
        jQuery('.email-installer input').attr('required', false);

        jQuery('.email-wholesaler').hide();
        jQuery('.email-wholesaler input').attr('required', false);
    }

    function toggleQuotationNo() {
        if (jQuery('input[name="application_type"]:checked').val() === "laying_plan") {
            jQuery('#quotation-no-block').show();
            jQuery('#quotation-no-block input').attr('required', true);
            jQuery('#quotation-data').hide();
            toggleRequiredFields(false);
        } else {
            jQuery('#quotation-no-block').hide();
            jQuery('#quotation-no-block input').attr('required', false);
            jQuery('#quotation-data').show();
            toggleRequiredFields(true);
        }
    }

    function toggleRequiredFields(display) {
        if (display) {
            jQuery('#quotation-data input#reference').attr('required', true);
            jQuery('#quotation-data input#street').attr('required', true);
            jQuery('#quotation-data input#postal_code').attr('required', true);
            jQuery('#quotation-data input#city').attr('required', true);
            jQuery('#quotation-data sekect#country').attr('required', true);
        } else {
            jQuery('#quotation-data input').attr('required', false);
            jQuery('#quotation-data select').attr('required', false);
        }
    }

    function matchHeight() {
        jQuery('.form-row label').matchHeight({
            byRow: true,
            property: 'height'
        });
    }

    return {
        init: function () {
            matchHeight()
            handleStart()
            handleStep1()
            handleStep2()
            handleStep4()
            handleDeleteFile()
        }
    }

})()

var Confirmation = (function () {

    var progressStart = 0;
    var progressInterval = false;

    function loader() {

        var $confirmationPage = jQuery('#p-confirmation');
        var $progressBar = $confirmationPage.find('.progress');
        var $progressState = $confirmationPage.find('.progress-state');

        if ($confirmationPage.length > 0) {

            progressInterval = setInterval(function(){
                if(progressStart < 100){
                    progressStart++;
                    $progressState.find('.number').html(progressStart);
                    $progressBar.find('.progress-bar').width(progressStart  + '%');
                }
                else {
                    if(progressInterval){
                        clearInterval(progressInterval);
                    }
                }
            },100);

        }
    }

    return {
        init: function () {
            loader()
        }
    }
})()

var SmartFiltering = (function () {

    var rules = {
        tacker: {
            PE_XA: {
                d14x2: {
                    includingPlacement: false,
                },
                d20x2: {
                    includingPlacement: false
                },
                d16x2: {}
            },
            PE_RT: {
                d14x2: {
                    includingPlacement: false
                },
                d20x2: {
                    includingPlacement: false
                },
                d16x2: {}
            },
            Aluflex: {
                d16x2: {}
            }
        },
        nets_clipped: {
            PE_XA: {
                d16x2: {
                    includingPlacement: false
                },
                d20x2: {
                    includingPlacement: false
                },
                d16x2: {}
            },
            PE_RT: {
                d16x2: {
                    includingPlacement: false
                },
                d20x2: {
                    includingPlacement: false
                },
                d16x2: {}
            },
            Aluflex: {
                d16x2: {
                    includingPlacement: false
                }
            }
        },
        nets_binded: {
            PE_XA: {
                d14x2: {
                    includingPlacement: false
                },
                d20x2: {
                    includingPlacement: false
                }
            },
            PE_RT: {
                d14x2: {
                    includingPlacement: false
                },
                d20x2: {
                    includingPlacement: false
                }
            },
            Aluflex: {
                d16x2: {}
            }
        },
        plate_11: {
            PE_XA: {
                d16x2: {
                    includingPlacement: false
                }
            },
            PE_RT: {
                d16x2: {
                    includingPlacement: false
                }
            }
        },
        plate_30: {
            PE_XA: {
                d16x2: {
                    includingPlacement: false
                }
            },
            PE_RT: {
                d16x2: {
                    includingPlacement: false
                }
            }
        },
        foil: {
            PE_XA: {
                d16x2: {}
            },
            PE_RT: {
                d16x2: {}
            },
        },
        dry: {
            PE_XA: {
                d14x2: {
                    includingPlacement: false
                }
            }
        },
        milling: {
            PE_XA: {
                d14x2: {
                    includingPlacement: true
                }
            }
        },
        wall_heating: {
            PE_XA: {
                d14x2: {
                    includingPlacement: false
                }
            }
        }


    };


    var includingPlacementRestricted = false;
    var includingPlacement = false;

    var $systemSelect = $("select#system");
    var $pipeSelect = $("select#pipe_type");
    var $diameterSelect = $("select#diameter_type");

    // radios
    var $includingPlacementYes = $("input#including-placement-yes");
    var $includingPlacementNo = $("input#including-placement-no");

    var $selectDisabled = $(".select-disabled");
    var $selectRadio = $(".radio-disabled");

    var selectedSystem, selectedPipe, selectedDiameter;

    var isProcessing = false;

    function loader() {

        resetFilter(-1)
        runFilter();

        // select 1
        $systemSelect.change(function() {
            if(isProcessing){
                return;
            }
            selectedSystem = $(this).val();
            resetFilter(1);
            runFilter();
        });

        // select 2
        $pipeSelect.change(function() {
            if(isProcessing){
                return;
            }
            selectedPipe = $(this).val();
            resetFilter(2);
            runFilter();
        });

        // select 3
        $diameterSelect.change(function() {
            if(isProcessing){
                return;
            }
            selectedDiameter = $(this).val();
            resetFilter(3);
            runFilter();
        });


        // Alerts
        $selectDisabled.click(function() {
            var alertId = $(this).data('alert-id');
            var alertText = $(this).data('alert');
            if(!alertId){
                alert(alertText);
                return;
            }
            resetAlert();
            $(alertId).html(alertText);
        });

        $selectRadio.click(function() {
            var alertId = $(this).data('alert-id');
            var alertText = includingPlacementRestricted ? $(this).data('alert-disabled') : $(this).data('alert');
            if(!alertId){
                alert(alertText);
                return;
            }
            resetAlert();
            $(alertId).html(alertText);
        });

    }

    function setFirstOption($element, level){

        if(
            level === 1 && selectedPipe != '' ||
            level === 2 && selectedDiameter !=''
        ){
            return
        }

        var firstVal = '';
        $element.find('option').each(function()
        {
            if($(this).css('display') != 'none' && $(this).val() != '')
            {
                firstVal = $(this).val();
                setTimeout(function(){
                    $element.val(firstVal).trigger('change');
                }, 100)

                return;
            }
        });

    }

    function resetAlert(){
        $('.text-danger--alert').html('');
    }

    function resetFilter(level){

        if(level <= 0){ // start
            $pipeSelect.prop('disabled', true);
            $diameterSelect.prop('disabled', true);

            selectedSystem = $systemSelect.val();
            selectedPipe = $pipeSelect.val();
            selectedDiameter = $diameterSelect.val();
        }
        else if(level === 1){
            $pipeSelect.val('');
            $diameterSelect.val('');

            selectedPipe = '';
            selectedDiameter = '';

            $pipeSelect.prop('disabled', true);
            $diameterSelect.prop('disabled', true);

        }
        else if(level === 2){
            $diameterSelect.val('');
            selectedDiameter = '';
            $diameterSelect.prop('disabled', true);
        }

        $includingPlacementYes.prop('checked', false).prop('disabled', true);
        $includingPlacementNo.prop('checked', false).prop('disabled', true);

        includingPlacementRestricted = false;
        includingPlacement = false;

        // hide all options
        $systemSelect.find('option:not([value=""])').hide();
        $pipeSelect.find('option:not([value=""])').hide();
        $diameterSelect.find('option:not([value=""])').hide();

    }

    function runFilter(){

        if(isProcessing){
            return;
        }

        isProcessing = true;
        var selectedSystemAmount = 0;
        var selectedPipeAmount = 0;
        var selectedDiameterTypeAmount = 0;

        resetAlert();

        $.each(rules, function(system, level_1) {
            selectedSystemAmount++;

            // show system by rule
            var $optionEl = $systemSelect.find(`option[value="${system}"]`);
            if($optionEl){
                $optionEl.show();
            }

            if(system === selectedSystem){

                $.each(level_1, function(pipe_type, level_2) {

                    // show pipe_type by rule
                    var $optionEl = $pipeSelect.find(`option[value="${pipe_type}"]`);
                    if($optionEl){
                        $pipeSelect.prop('disabled', false)
                        $optionEl.show();
                        selectedPipeAmount++
                    }

                    if(pipe_type === selectedPipe){

                        $.each(level_2, function(diameter_type, level_3) {

                            // show diameter_type by rule
                            var $optionEl = $diameterSelect.find(`option[value="${diameter_type}"]`);
                            if($optionEl){
                                $diameterSelect.prop('disabled', false)
                                $optionEl.show();
                                selectedDiameterTypeAmount++
                            }

                            if(diameter_type === selectedDiameter){
                                if(level_3 && level_3.hasOwnProperty('includingPlacement')){
                                    includingPlacementRestricted = true;
                                    includingPlacement = level_3.includingPlacement;

                                    if(includingPlacement){
                                        $includingPlacementYes.prop('checked', true);
                                    }
                                    else {
                                        $includingPlacementNo.prop('checked', true);
                                    }

                                }

                                if(includingPlacementRestricted){
                                    $includingPlacementNo.prop('disabled', includingPlacement);
                                    $includingPlacementYes.prop('disabled', !includingPlacement);
                                }
                                else {
                                    $includingPlacementYes.prop('disabled', false);
                                    $includingPlacementNo.prop('disabled', false);
                                }

                            }

                        });
                        if(selectedDiameterTypeAmount === 1){
                            setFirstOption($diameterSelect, 2);
                        }

                    }

                });
                console.log({ selectedPipeAmount });
                if(selectedPipeAmount === 1){
                    setFirstOption($pipeSelect, 1);
                }
            }

        });

        isProcessing = false;

    }

    return {
        init: function () {
            loader()
        }
    }
})()

jQuery(document).ready(function () {
    Form.init()
    Confirmation.init()
    SmartFiltering.init();
})
